import { Component, forwardRef, Injector, StaticProvider } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { ControlBase } from "../control-base";

const EmailValueAccessor = <StaticProvider>{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => EmailControlComponent),
    multi: true
};

@Component({
    selector: "m-email-control",
    template: `
        <div class="flex align-items-center justify-content-end">
            <input [disabled]="disabled" type="email" autoSaveIgnore pInputText [(ngModel)]="email" (blur)="_onBlur()" />
            <ng-content></ng-content>
        </div>
    `,
    providers: [EmailValueAccessor]
})
export class EmailControlComponent extends ControlBase<string> {
    private _email: string;

    get email() {
        return this._email;
    }

    set email(email: string) {
        this._email = email;
        this.onChange(this._email);
    }

    writeValue(obj: string): void {
        this._email = obj;
    }
}
